import React, {FunctionComponent} from "react";
import "./VariantProposalCard.scss";
import {InvoiceOption} from "../../models/item.model";
import {Button} from "../ui-components/Button/Button";

export interface VariantProposalCardProps {
    option: InvoiceOption;
    price: string;
    shouldDisplayPhotoOutlet: boolean;
    isHighlighted: boolean;
    isDisabled: boolean;
    onSelect: (option: InvoiceOption) => void;
}

export const getVariantProposalOptionTitle = (option: InvoiceOption | null): string => {
    if (!option) {
        return '';
    }
    return option.title || option.tab_title || option.option_name;
};

export const VariantProposalCard: FunctionComponent<VariantProposalCardProps> = (props) => {
    const {option, price, shouldDisplayPhotoOutlet, isHighlighted, isDisabled} = props;
    const title = getVariantProposalOptionTitle(option);

    const renderPhoto = () => {
        if (option.photo_src) {
            return <section className="variant-proposal-card-photo"><img src={option.photo_src} alt={title}/></section>;
        }
        if (shouldDisplayPhotoOutlet) {
            return <section className="variant-proposal-card-photo"><i className="fa-regular fa-file-image photo-outlet"/></section>;
        }
        return null;
    };

    const classNames = [
        'variant-proposal-card',
        isHighlighted ? 'selected-card' : '',
        !option.photo_src && !shouldDisplayPhotoOutlet ? 'no-photo-card' : ''
    ].filter(Boolean).join(' ');

    return (
        <article className={classNames}>
            {renderPhoto()}
            <section className="variant-proposal-card-description">
                <h3>{title}</h3>
                <p className="variant-proposal-card-description-text">{option.description}</p>
            </section>
            <section className="variant-proposal-card-actions">
                <div className="variant-proposal-card-price">{price}</div>
                <Button className="green-button" disabled={isDisabled} onClick={() => props.onSelect(option)}>Select</Button>
            </section>
        </article>
    );
};
